import { render, staticRenderFns } from "./GlobalPayLayer.vue?vue&type=template&id=10a3c5c0&scoped=true&"
import script from "./GlobalPayLayer.vue?vue&type=script&lang=js&"
export * from "./GlobalPayLayer.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPayLayer.vue?vue&type=style&index=0&id=10a3c5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3c5c0",
  null
  
)

export default component.exports